import React, { useState } from 'react';
import { Button, Row, Col, Card, CardBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import Breadcrumbs from '../../components/Breadcrumb';
import UserTasksTable from './components/Tasks-table';
import PageStructure from 'components/Page-Structure';

const ActivitiesList = () => {
  const { t: translate } = useTranslation();

  return (
    <PageStructure metaTitle="Activities">
      <Row>
        <Col xs="12" className="mb-4 d-flex align-items-center justify-content-between">
          <h4 className="mb-0 font-size-18">{translate('My Activity')}</h4>
          <Breadcrumbs title={translate('Activities')} />
        </Col>
      </Row>
      <Card>
        <UserTasksTable />
      </Card>
    </PageStructure>
  );
};

export default ActivitiesList;
